import client from "../Client/HttpClient";
import { IPreschoolDimensionsModel } from "@/interfaces/modules";

const ApiPath = "PreschoolDimensions";

export default {
    GetPreschoolDimensions: (): Promise<IPreschoolDimensionsModel[]> => client.get(`${ApiPath}`),
    GetPreschoolDimensionById: (Id: number): Promise<IPreschoolDimensionsModel> => client.get(`${ApiPath}/${Id}`),
    PostPreschoolDimension: (data: IPreschoolDimensionsModel): Promise<IPreschoolDimensionsModel> => client.post(`${ApiPath}`, data)
};
